export const STATUS = {
  aguardando: { hex: "#FBBF24", glyph: "…", label: "aguardando resposta" },
  aceitou: { hex: "#34D399", glyph: "✓", label: "confirmado" },
  a_caminho: { hex: "#3B82F6", glyph: "→", label: "a caminho" },
  proximo: { hex: "#60A5FA", glyph: "→", label: "chegando" },
  chegou: { hex: "#10B981", glyph: "★", label: "chegou" },
  cancelou: { hex: "#F87171", glyph: "✕", label: "cancelou" },
  recusou: { hex: "#A1A1AA", glyph: "✕", label: "recusou" },
  expirou: { hex: "#A1A1AA", glyph: "!", label: "não respondeu a tempo" },
};
const PLANTAO = { hex: "#FF8A3D", glyph: "P", label: "em Plantão" };
const DISP = { hex: "#34D399", glyph: "D", label: "disponível", dash: true };

export const musicianColor = (m) => (m.status ? STATUS[m.status] : m.oncall_status === "ativo" ? PLANTAO : DISP);
export const musicianLabel = (m) => musicianColor(m).label;

const hash = (s) => [...String(s || "")].reduce((a, ch) => (a * 31 + ch.charCodeAt(0)) >>> 0, 7);

// Direção fictícia e estável por músico: a distância é aproximada e a posição nunca é a real.
export function approxPos(c, distKm, i, id) {
  const d = Math.max(0.6, Math.min(distKm, 20));
  const brg = ((id ? hash(id) % 360 : i * 47 + 20) * Math.PI) / 180;
  return [c.lat + (d / 111) * Math.cos(brg), c.lng + (d / (111 * Math.cos((c.lat * Math.PI) / 180))) * Math.sin(brg)];
}

export const LEGEND_PRE = [PLANTAO, DISP];
export const LEGEND_LIVE = [STATUS.aguardando, STATUS.aceitou, STATUS.a_caminho, STATUS.chegou, STATUS.recusou];
